import axios from 'axios';

export default {
    mounted() {
        var vm = this;
        this.axios = axios.create();
        this.axios.interceptors.request.use(
            function (config) {
                vm.httpIsBusy = true;
                return config;
            },
            function (error) {
                // Do something with request error
                vm.httpIsBusy = false;
                return Promise.reject(error);
            }
        );
        this.axios.interceptors.response.use(
            function (response) {
                vm.httpIsBusy = false;
                return response;
            },
            function (error) {
                if (error.response.status === 401) {
                    window.location.href =
                        '/identity/account/login?ReturnUrl=%2F' + vm.path;
                } else if (error.response.status === 403) {
                    window.location.href =
                        '/identity/account/accessdenied?ReturnUrl=%2F' + vm.path;
                } else {
                    // eslint-disable-next-line no-console
                    console.log('HTTP   ', error.toJSON());
                    vm.httpIsBusy = false;
                }
                return Promise.reject(error);
            }
        );
    },
    data() {
        return {
            httpIsBusy: false,
            axios: null,
            path: ''
        };
    },
    methods: {}
};
